<template>
  <div>
    <div
      class="ko-progress-circle"
      v-show="percentage !== 100"
      :data-progress="percentage"
      :style="`transform: scale(${scale})`"
    >
      <div class="ko-circle">
        <div class="full ko-progress-circle__slice">
          <div class="ko-progress-circle__fill"></div>
        </div>
        <div class="ko-progress-circle__slice">
          <div class="ko-progress-circle__fill"></div>
          <div class="ko-progress-circle__fill ko-progress-circle__bar"></div>
        </div>
      </div>
      <div class="ko-progress-circle__overlay" :style="`background-color: ${centerColor}`"></div>
    </div>
    <transition name="zoom">
      <svg
        v-show="percentage === 100"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 426.667 426.667"
        style="enable-background:new 0 0 426.667 426.667;"
        xml:space="preserve"
      >
        <path
          style="fill:#f88;"
          d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333
	c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622
	l140.894-140.898l31.309,31.309L174.199,322.918z"
        />
      </svg>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0
    },
    centerColor: {
      type: String,
      default: "#ffffff"
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      progress: 0
    };
  },
  methods: {
    updateData() {
      this.progress = this.percentage;
    }
  },
  mounted() {
    setTimeout(() => {
      this.progress = this.percentage;
    }, 500);
  }
};
</script>

<style lang="scss" scoped>
$circle-size: 30px;
$circle-background: #eee;
$circle-color: #f88;
$inset-size: 20px;
$inset-color: white;
$transition-length: 1s;

.ko-progress-circle {
  width: $circle-size;
  height: $circle-size;

  background-color: $circle-background;
  border-radius: 50%;
  .ko-progress-circle__slice,
  .ko-progress-circle__fill {
    width: $circle-size;
    height: $circle-size;
    position: absolute;
    transition: transform $transition-length;
    border-radius: 50%;
  }
  .ko-progress-circle__slice {
    clip: rect(0px, $circle-size, $circle-size, $circle-size/2);
    .ko-progress-circle__fill {
      clip: rect(0px, $circle-size/2, $circle-size, 0px);
      background-color: $circle-color;
    }
  }
  .ko-progress-circle__overlay {
    width: $inset-size;
    height: $inset-size;
    position: absolute;
    margin-left: ($circle-size - $inset-size)/2;
    margin-top: ($circle-size - $inset-size)/2;

    background-color: $inset-color;
    border-radius: 50%;
  }

  $i: 0;
  $increment: 180deg / 100;
  @while $i <= 100 {
    &[data-progress="#{$i}"] {
      .ko-progress-circle__slice.full,
      .ko-progress-circle__fill {
        transform: rotate($increment * $i);
      }
      .ko-progress-circle__fill.ko-progress-circle__bar {
        transform: rotate($increment * $i * 2);
      }
      $i: $i + 1;
    }
  }
}

svg {
  width: 30px;
  height: 30px;
  margin: 0;
}

.zoom-enter-active {
  transition: all 0.3s;
}
.zoom-enter /* .zoom-leave-active below version 2.1.8 */ {
  transform: scale(0.4);
  opacity: 0;
}
</style>
